var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiAssetsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.618 4.219a7.26 7.26 0 0 1 7.281 7.28 7.26 7.26 0 0 1-7.281 7.282 7.26 7.26 0 0 1-7.281-7.284 7.262 7.262 0 0 1 7.28-7.278zm-11.934 13.54c-1.987-2.362-5.722-2.229-7.521.346L1.377 33.532l-.09.14-.077.15c-.449.96-.16 2.074.69 2.67a2.125 2.125 0 0 0 2.96-.525L15.646 20.54l.051-.067.061-.058c.199-.155.538-.119.708.126l5.494 7.888.115.156.137.163c1.544 1.746 4.322 1.624 5.681-.296l.564-.797.054-.068.06-.058c.198-.152.533-.115.703.127l5.856 8.317.101.13.122.13c.75.744 1.892.85 2.738.254a2.125 2.125 0 0 0 .514-2.961l-5.856-8.317-.117-.16-.14-.172-.15-.168c-2.027-2.18-5.595-1.994-7.354.49l-.049.07-4.985-7.157-.118-.161-.152-.191zm8.715-6.26a3.2 3.2 0 0 1 3.219-3.218 3.198 3.198 0 0 1 3.219 3.219 3.198 3.198 0 0 1-3.22 3.219 3.198 3.198 0 0 1-3.218-3.22z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiAssetsIcon);
export default __webpack_public_path__ + "static/media/ui-assets-icon.0194914258d769c7282adc9b137b4bc7.svg";
export { ForwardRef as ReactComponent };